import { SITE_SYNC_SECTION } from '@/features/settingsPage/consts/sections';
import { getSectionUrl } from '@/features/settingsPage/structs/section';

export const ROUTE_PATH = getSectionUrl(SITE_SYNC_SECTION);

export const FEATURE_NAME = 'siteSyncPage';
